import { ClientTokenPayload, useAuthStore } from 'src/common/store'
import { onSignalREvent } from '../../signalRBus'
import { useClientContextStore } from 'src/client/stores'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'

onSignalREvent(
  SIGNAL_R_SCOPES.system,
  SIGNAL_R_MESSAGES.portalRegistrationCreated,
  (text) => {
    const authStore = useAuthStore()
    if (!authStore.isClient) return
    const clientContextStore = useClientContextStore()
    const eventFamilyId = text.split('_').pop()
    const loggedInFamilyId = (authStore.tokenPayload as ClientTokenPayload)
      ?.extension_FamilyId
    if (eventFamilyId !== loggedInFamilyId) return
    void clientContextStore.fetchFamilyDashboard()
  },
)
